import React from "react";
import styled from "styled-components";
import * as Yup from "yup";
import { FIELD_NAMES } from "../../../../../constants/commonConstants";
import { MANAGE_REPAYMENTS_INCREASE_ROUTE } from "../route.constants";
import { PRIVATE_ROUTE } from "../../../../../route.constants";
import { MoneyInput } from "../../../../Forms/components/fields";
import { getIncreaseRepaymentsEndpoint } from "../../../../../services/apiRoutes";
import { withLoanForm } from "../../../../../components/fairGoForm/withLoanForm";
import { ManageRepaymentForm } from "../../../components/manageRepaymentForm";
import { DatePickerManageRepayment } from "./MakeExtraRepayments/datePickerManageRepayments";
import { useAccount } from "../../../../../hooks/client";
import { useSetDefaultValue } from "../../../../../hooks/index";
import { Wrapper } from "./loanFormsWithDatePicker.styles";
import { Wrapper as ModalWrapper } from "../../../components/manageMyRepaymentModal/manageMyRepaymentModal.styles";
import {
  addDaysAfterToday,
  addBusinessDaysAfterToday,
  getValidDates,
  createWorkDaySelectOptions,
  createRequiredDateDropdownShape,
} from "./MakeExtraRepayments/utils/dateHelpersManageRepayments";
import { useSetClientSideFieldValue, useCheckIfFormIsActive } from "../../../hooks";

const ModalMessage = () => {
  return (
    <ModalWrapper>
      <p>Thank you. Your request has been received.</p>
    </ModalWrapper>
  );
};

const PayHigherWrapper = styled(Wrapper)`
  padding: 30px 40px;
`;
const validDateTimes = getValidDates(
  addBusinessDaysAfterToday(2),
  addDaysAfterToday(90)
);
const filteredDates = createWorkDaySelectOptions(validDateTimes);

const INITIAL_FORM_STATE = {
  [FIELD_NAMES.PAYMENT_VALUE]: "",
  [FIELD_NAMES.START_DATE]: { day: "", month: "", year: "" },
  __clientsideonly__startDate: "",
};

const FORM_VALIDATION = Yup.object().shape({
  [FIELD_NAMES.PAYMENT_VALUE]: Yup.string()
    .trim()
    .required("Field is required")
    .when(
      [
        FIELD_NAMES.CONTRACTUAL_PAYMENT_REGULAR,
        FIELD_NAMES.MINIMUM_PAYMENT_VALUE,
        FIELD_NAMES.ACCOUNT_TYPE,
      ],
      (paymentRegular, minimumPaymentValue, accountType, schema) => {
        if (accountType !== "LOC") {
          return schema.test({
            test: (paymentValue) => {
              return paymentValue > paymentRegular;
            },
            message: `Value must be higher than $${paymentRegular}`,
          });
        } else {
          return schema.test({
            test: (paymentValue) => {
              return paymentValue > minimumPaymentValue;
            },
            message: `Value must be higher than $${minimumPaymentValue}`,
          });
        }
      }
    ),

  [FIELD_NAMES.START_DATE]: Yup.object()
    .required("Please select a date")
    .shape(createRequiredDateDropdownShape()),
});

const _PayHigherAmountForm = ({ accountId }) => {
  const { contractedPaymentRegular, minimumPaymentValue, accountType } =
  useAccount(accountId) || {};

  useSetClientSideFieldValue(
    FIELD_NAMES.CONTRACTUAL_PAYMENT_REGULAR,
    contractedPaymentRegular
  );
  useSetClientSideFieldValue(
    FIELD_NAMES.MINIMUM_PAYMENT_VALUE,
    minimumPaymentValue
  );
  useSetClientSideFieldValue(FIELD_NAMES.ACCOUNT_TYPE, accountType);
  useSetDefaultValue(FIELD_NAMES.PAYMENT_VALUE, "");

  return (
    <div className="input-wrapper">
      <MoneyInput
        className="pay-higher-input"
        decimalPlaces={2}
        name={FIELD_NAMES.PAYMENT_VALUE}
        title="How much will you pay?"
        label="amount"
      />
      <DatePickerManageRepayment
        title="Start date"
        className="start-date-label"
        name={FIELD_NAMES.START_DATE}
        options={filteredDates}
        placeholder="Select Date"
      />
    </div>
  );
};

const PayHigherAmountForm = withLoanForm(_PayHigherAmountForm);

export const PayHigherAmount = ({ accountId }) => {
  const match =
    PRIVATE_ROUTE.MANAGE_REPAYMENTS +
    MANAGE_REPAYMENTS_INCREASE_ROUTE.INCREASE +
    MANAGE_REPAYMENTS_INCREASE_ROUTE.INCREASE_HIGHER;

  const isActive = useCheckIfFormIsActive(match);

  return (
    <PayHigherWrapper>
      <ManageRepaymentForm
        buttonText="I Agree And Confirm My Request"
        endpoint={getIncreaseRepaymentsEndpoint(accountId)}
        initialValues={{ ...INITIAL_FORM_STATE }}
        validationSchema={FORM_VALIDATION}
        isActive={isActive}
        modalMessage={<ModalMessage />}
      >
        <PayHigherAmountForm accountId={accountId} />
      </ManageRepaymentForm>
    </PayHigherWrapper>
  );
};
